import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcTicket(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.5 16.694c1.092 0 2.029.637 2.473 1.556H20a.25.25 0 0 0 .245-.2l.005-.05V6a.25.25 0 0 0-.25-.25h-2.027a2.744 2.744 0 0 1-4.946 0H4a.25.25 0 0 0-.25.25v12l.005.05a.25.25 0 0 0 .245.2h9.027a2.74 2.74 0 0 1 2.473-1.556M21.75 18A1.75 1.75 0 0 1 20 19.75h-2.552a.75.75 0 0 1-.731-.584 1.248 1.248 0 0 0-2.434 0 .75.75 0 0 1-.731.584H4A1.75 1.75 0 0 1 2.25 18V6c0-.966.784-1.75 1.75-1.75h9.552a.75.75 0 0 1 .731.584 1.249 1.249 0 0 0 2.434 0 .75.75 0 0 1 .731-.584H20c.966 0 1.75.784 1.75 1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.25 10.5a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 1.5 0zM16.25 15a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 1.5 0z"
  }));
}
var IcTicket = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTicket));

export { IcTicket as I };
